import { render, staticRenderFns } from "./ObjectiveTasksDialog.vue?vue&type=template&id=89fa068a&scoped=true&"
import script from "./ObjectiveTasksDialog.vue?vue&type=script&lang=js&"
export * from "./ObjectiveTasksDialog.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveTasksDialog.vue?vue&type=style&index=0&id=89fa068a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fa068a",
  null
  
)

export default component.exports